export const genderValues = [
  'man',
  'woman',
  'other',
  'prefer_not_to_say',
] as const;
export type Gender = (typeof genderValues)[number];
